var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "smart-enhancement-view" }, [
    _c("div", { staticClass: "smart-enhancement-view-images" }, [
      _c("div", { staticClass: "smart-enhancement-view-image-container" }, [
        _c("img", {
          staticClass: "smart-enhancement-view-image",
          attrs: { src: _vm.imageUrlBefore },
        }),
        _c("div", { staticClass: "smart-enhancement-view-image-placeholder" }, [
          _vm._v(_vm._s(_vm.$t("views.smartEnhancement.before"))),
        ]),
      ]),
      _c("div", { staticClass: "smart-enhancement-view-image-container" }, [
        _c("img", {
          staticClass: "smart-enhancement-view-image",
          attrs: { src: _vm.imageUrlAfter },
        }),
        _c("div", { staticClass: "smart-enhancement-view-image-placeholder" }, [
          _vm._v(_vm._s(_vm.$t("views.smartEnhancement.after"))),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "smart-enhancement-view-description" }, [
      _vm._v(_vm._s(_vm.$t("views.smartEnhancement.changeSmartEnhancement"))),
    ]),
    _vm.showSwitchBox
      ? _c(
          "div",
          { staticClass: "smart-enhancement-view-toggle" },
          [
            _c(
              "SwitchBoxComponent",
              {
                attrs: { value: _vm.internalValue },
                on: { change: _vm.onSmartEnhancementChange },
              },
              [_vm._v(_vm._s(_vm.$t("views.smartEnhancement.toggle")))]
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }